<template>
    <Dropdown
        ref="dropdown"
        :value="value"
        class="w-full"
        :placeholder="$t('editor.style_presets.placeholder')"
        :options="presets"
        option-label="name"
        option-value="id"
        :append-to="appendTo"
        @show="$emit('show', $refs.dropdown)"
        @hide="$emit('hide')"
        @change="$emit('select', presets.find((preset) => preset.id === $event.value))"
    >
        <template #value="slotProps">
            <div v-if="selected" class="flex items-center">
                <span class="preset-preview mr-4" :style="selected.preview" :class="selected.fontClass">Aa</span>
                <span>{{ optionName(selected) }}</span>
            </div>
            <span v-else class="p-placeholder">{{ slotProps.placeholder }}</span>
        </template>
        <template #option="{ option }">
            <div class="flex items-center pointer-events-none text-base">
                <span class="preset-preview mr-4" :style="option.preview" :class="option.fontClass">Aa</span>
                <span>{{ optionName(option) }}</span>
            </div>
        </template>
    </Dropdown>
</template>

<script>
export default {
    name: 'StylePresetSelect',
    props: {
        presets: {
            type: Array,
            required: true,
        },
        value: {
            type: Number,
            default: null,
        },
        appendTo: {
            type: [String, Object],
            default: null,
        },
    },
    emits: ['select', 'show', 'hide'],
    computed: {
        selected() {
            return this.presets.find((preset) => preset.id === this.value) || null;
        },
    },
    methods: {
        // option lists keep `name` (saved with orders) and add `labelKey` for display
        optionName(option) {
            return option.labelKey ? this.$t(option.labelKey) : option.name;
        },
    },
};
</script>
